import T from 'utils/T';
import ex from 'utils/ex';
import useCategorizedPages from 'hooks/app/useCategorizedPages';
import PageOutlet from '../PageOutlet';
import VBox from 'components/common/VBox';
import ReportTabs from './ReportTabs';
import FocusableButton from 'components/common/FocusableButton';


import HBox from 'components/common/HBox';
import DownloadButton from './DownloadButton';

const category = 'Report';
export default function Report(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props;

  const pages = useCategorizedPages(category);
  return (
    <VBox
      {...ex('Page', rest)}
    >
      <ReportTabs {...rest} {...{ category }} >
        {/* <FocusableButton {...ex(['ViewModeButton', { selected: viewMode === 'ReportExerciseSteps' }], { onClick: onSwitchViewMode(0) })}>
          {T('평균걸음수')}
        </FocusableButton>
        <FocusableButton {...ex(['ViewModeButton', { selected: viewMode === 'ReportExerciseCalories' }], { onClick: onSwitchViewMode(1) })}>
          {T('소모칼로리')}
        </FocusableButton> */}

        <DownloadButton />
      </ReportTabs>
      <PageOutlet
        {...{
          renderAll,
          category,
          pages,
        }}
      />
    </VBox>
  );
}
